import React, { Component } from 'react'
import {Grid,Col,Image} from "react-bootstrap"
import "./About.css"

export default class About extends Component {
  render() {
    return (
        <div>
            <Image src="assets/dog-people.jpg" className="header-image" />
            <Grid>
                <Col xs={12} sm={8} smOffset={2}>
                <Image src="assets/person-1.jpg" className="about-profile-pic" rounded />
                <h3>Frank The Tank</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                 Maxime illo repellendus cumque ullam non fuga adipisci nobis pariatur officia porro distinctio aliquam explicabo id nulla in consectetur, 
                 quod, consequatur deleniti.</p>
                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                 Maxime illo repellendus cumque ullam non fuga adipisci nobis pariatur officia porro distinctio aliquam explicabo id nulla in consectetur, 
                 quod, consequatur deleniti.</p>
                 <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                 Maxime illo repellendus cumque ullam non fuga adipisci nobis pariatur officia porro distinctio aliquam explicabo id nulla in consectetur, 
                 quod, consequatur deleniti.</p>
                </Col>


            </Grid>



        </div>

    )
  }
}
